import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Faq from "@/pages/Faq";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Security from "@/pages/Security";
import Pricing from "@/pages/Pricing";
import Features from "@/pages/Features";
import FeaturePage from "@/pages/FeaturePage";
import Login from "@/pages/Login";
import OAuthCallback from "@/pages/OAuthCallback";
import Plans from "@/pages/Plans";
import Dashboard from "@/pages/Dashboard";
import StatusGuide from "@/pages/StatusGuide";
import TabsGuide from "@/pages/TabsGuide";
import CatalogGuide from "@/pages/CatalogGuide";
import AnalyticsGuide from "@/pages/AnalyticsGuide";
import DiscountsGuide from "@/pages/DiscountsGuide";
import AbandonedCartGuide from "@/pages/AbandonedCartGuide";
import RazorpayKeysGuide from "@/pages/RazorpayKeysGuide";
import StripeKeysGuide from "@/pages/StripeKeysGuide";
import PaypalKeysGuide from "@/pages/PaypalKeysGuide";
import CatalogPage from "@/pages/CatalogPage";
import PublicStorefront from "@/pages/PublicStorefront";
import PublicProductPage from "@/pages/PublicProductPage";
import StorefrontCheckout from "@/pages/StorefrontCheckout";
import PublicCatalogGuide from "@/pages/PublicCatalogGuide";
import PublicCatalogSettings from "@/pages/PublicCatalogSettings";
import ProfilePage from "@/pages/ProfilePage";
import TeamPage from "@/pages/TeamPage";
import TeamGuide from "@/pages/TeamGuide";
import HelpGuide from "@/pages/HelpGuide";
import ReferralGuide from "@/pages/ReferralGuide";
import RequireOwner from "@/components/RequireOwner";
import NotFound from "@/pages/NotFound";
import Error500 from "@/pages/Error500";
import Maintenance from "@/pages/Maintenance";
import LoginFailed from "@/pages/LoginFailed";
import PaymentCancelled from "@/pages/PaymentCancelled";
import PaymentComplete from "@/pages/PaymentComplete";
import PaymentFailed from "@/pages/PaymentFailed";
import InstagramConnectionFailed from "@/pages/InstagramConnectionFailed";
import AccountDisconnected from "@/pages/AccountDisconnected";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import RefundPolicy from "@/pages/RefundPolicy";
import DataDeletion from "@/pages/DataDeletion";
import AboutUs from "@/pages/AboutUs";
import ContactUs from "@/pages/ContactUs";
import Billing from "@/pages/Billing";
import Analytics from "@/pages/Analytics";
import ShippingPage from "@/pages/ShippingPage";
import CourierPage from "@/pages/CourierPage";
import Webhooks from "@/pages/Webhooks";
import WebhooksGuide from "@/pages/WebhooksGuide";
import BulkImageUploadGuide from "@/pages/BulkImageUploadGuide";
import ShiprocketTrackingGuide from "@/pages/ShiprocketTrackingGuide";
import ShippoTrackingGuide from "@/pages/ShippoTrackingGuide";
import ScrollToTop from "@/components/ScrollToTop";
import NoIndexGuard from "@/components/NoIndexGuard";
import ReferralCapture from "@/components/ReferralCapture";
import RouteErrorBoundary from "@/components/RouteErrorBoundary";
import CookieConsent from "@/components/CookieConsent";
import TeamAccept from "@/pages/TeamAccept";
import TeamLogin from "@/pages/TeamLogin";
import AdminLogin from "@/admin/pages/AdminLogin";
import AdminLoginVerify from "@/admin/pages/AdminLoginVerify";
import AdminCoupons from "@/admin/pages/AdminCoupons";
import AdminMerchants from "@/admin/pages/AdminMerchants";
import AdminFeedbackPage from "@/admin/pages/AdminFeedbackPage";
import AdminUnblock from "@/admin/pages/AdminUnblock";
import AdminReferrals from "@/admin/pages/AdminReferrals";

function App() {
  return (
    <div className="App bg-cream text-ink min-h-screen">
      <BrowserRouter>
      <ScrollToTop />
      <NoIndexGuard />
      <ReferralCapture />
        <RouteErrorBoundary>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/security" element={<Security />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/features" element={<Features />} />
          <Route path="/features/:slug" element={<FeaturePage />} />
          <Route path="/compare" element={<FeaturePage slug="compare" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/oauth/callback" element={<OAuthCallback />} />
          <Route path="/connected" element={<OAuthCallback />} />
          <Route path="/plans" element={<Plans />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/team/accept" element={<TeamAccept />} />
          <Route path="/team/login" element={<TeamLogin />} />
          <Route path="/status-guide" element={<StatusGuide />} />
          <Route path="/tabs-guide" element={<TabsGuide />} />
          <Route path="/catalog-guide" element={<CatalogGuide />} />
          <Route path="/analytics-guide" element={<AnalyticsGuide />} />
          <Route path="/discounts-guide" element={<DiscountsGuide />} />
          <Route path="/abandoned-cart-guide" element={<AbandonedCartGuide />} />
          <Route path="/razorpay-keys-guide" element={<RazorpayKeysGuide />} />
          <Route path="/stripe-keys-guide" element={<StripeKeysGuide />} />
          <Route path="/paypal-keys-guide" element={<PaypalKeysGuide />} />
          <Route path="/public-catalog-guide" element={<PublicCatalogGuide />} />
          <Route path="/shiprocket-tracking-guide" element={<ShiprocketTrackingGuide />} />
          <Route path="/shippo-tracking-guide" element={<ShippoTrackingGuide />} />
          <Route path="/catalog" element={<CatalogPage />} />
          <Route path="/public-catalog" element={<RequireOwner><PublicCatalogSettings /></RequireOwner>} />
          <Route path="/store/:username" element={<PublicStorefront />} />
          <Route path="/store/:username/checkout" element={<StorefrontCheckout />} />
          <Route path="/store/:username/p/:slug" element={<PublicProductPage />} />
          <Route path="/profile" element={<RequireOwner><ProfilePage /></RequireOwner>} />
          <Route path="/team" element={<RequireOwner><TeamPage /></RequireOwner>} />
          <Route path="/team-guide" element={<TeamGuide />} />
          <Route path="/help" element={<HelpGuide />} />
          <Route path="/referral-guide" element={<ReferralGuide />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/data-deletion" element={<DataDeletion />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/500" element={<Error500 />} />
          <Route path="/maintenance" element={<Maintenance />} />
          <Route path="/login-failed" element={<LoginFailed />} />
          <Route path="/payment-cancelled" element={<PaymentCancelled />} />
          <Route path="/payment-complete" element={<PaymentComplete />} />
          <Route path="/payment-failed" element={<PaymentFailed />} />
          <Route path="/instagram-connection-failed" element={<InstagramConnectionFailed />} />
          <Route path="/account-disconnected" element={<AccountDisconnected />} />
          <Route path="/billing" element={<RequireOwner><Billing /></RequireOwner>} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/shipping" element={<RequireOwner><ShippingPage /></RequireOwner>} />
          <Route path="/courier" element={<RequireOwner><CourierPage /></RequireOwner>} />
          <Route path="/webhooks" element={<RequireOwner><Webhooks /></RequireOwner>} />
          <Route path="/webhooks-guide" element={<WebhooksGuide />} />
          <Route path="/bulk-image-upload-guide" element={<BulkImageUploadGuide />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/login-verify" element={<AdminLoginVerify />} />
          <Route path="/admin/coupons" element={<AdminCoupons />} />
          <Route path="/admin/merchants" element={<AdminMerchants />} />
          <Route path="/admin/feedback" element={<AdminFeedbackPage />} />
          <Route path="/admin/unblock" element={<AdminUnblock />} />
          <Route path="/admin/referrals" element={<AdminReferrals />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        </RouteErrorBoundary>
        <CookieConsent />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
